import { useState } from 'react';
import { Shield } from 'lucide-react';
import AdminUserList from './AdminUserList';
import AdminTierEditor from './AdminTierEditor';
import AdminPricingEditor from './AdminPricingEditor';
import AdminLLMEditor from './AdminLLMEditor';

function AdminPanel({ onClose }) {
  const [tab, setTab] = useState('users');

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1300,
      display: 'flex', alignItems: 'stretch', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', width: '100%', maxWidth: 480,
        display: 'flex', flexDirection: 'column', overflowY: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #0A7C8A 0%, #05C4B0 100%)',
          padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 10,
          flexShrink: 0,
        }}>
          <Shield size={20} color="#fff" />
          <span style={{ color: '#fff', fontWeight: 800, fontSize: 18, flex: 1 }}>Admin Panel</span>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8,
              padding: '6px 14px', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13,
            }}
          >
            Close
          </button>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', borderBottom: '2px solid #E5E7EB', flexShrink: 0 }}>
          {[['users', 'Users'], ['tiers', 'Tier Config'], ['pricing', 'Pricing'], ['llm', 'Models']].map(([key, label]) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              style={{
                flex: 1, padding: '13px', border: 'none', background: 'none',
                fontSize: 13, fontWeight: 700, cursor: 'pointer',
                color: tab === key ? '#0A7C8A' : '#6B7280',
                borderBottom: tab === key ? '2px solid #0A7C8A' : '2px solid transparent',
                marginBottom: -2,
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div style={{ flex: 1, padding: 20, overflowY: 'auto' }}>
          {tab === 'users'   && <AdminUserList />}
          {tab === 'tiers'   && <AdminTierEditor />}
          {tab === 'pricing' && <AdminPricingEditor />}
          {tab === 'llm'     && <AdminLLMEditor />}
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
